export const CVE_WORKLOAD_EXPORTED_COLS = [
  'account_id',
  'cluster',
  'related_images',
  'workload_kind',
  'workload_name',
  'namespace',
  'runtime_instances',
  'vulnerability_counts',
];

export const CVE_WORKLOAD_EXPORTED_HEADERNAME = [
  'Account ID',
  'Cluster',
  'Images',
  'Workload Kind',
  'Workload Name',
  'Namespace',
  'Pod',
  'Vulnerabilities',
];

export const IMAGES_WORKLOAD_EXPORTED_COLS = [
  'account_id',
  'cluster',
  'related_images',
  'workload_kind',
  'workload_name',
  'namespace',
  'vulnerability_counts',
];

export const IMAGES_WORKLOAD_EXPORTED_HEADERNAME = [
  'Account ID',
  'Cluster',
  'Images',
  'Workload Kind',
  'Workload Name',
  'Namespace',
  'Vulnerabilities',
];
export const CVE_IMAGE_EXPORTED_COLS = ['name', 'related_workloads', 'cluster', 'vulnerability_counts'];

export const CVE_IMAGE_EXPORTED_HEADERNAME = ['Image', 'Workloads', 'Cluster', 'Vulnerabilities'];

export const COMPONENT_EXPORTED_COLS = ['name', 'type', 'version', 'related_images', 'vulnerability_counts'];

export const COMPONENT_EXPORTED_HEADERNAME = ['Component', 'Type', 'Fix Versions', 'Images', 'Vulnerabilities'];

export const VULNERABILITY_EXPORTED_COLS = [
  'account_id',
  'cluster',
  'vulnerability_id',
  'severity',
  'cvss_score',
  'exploitability_score',
  'exploitable',
  'in_use',
  'fix_version',
  'workload_name',
  'workload_kind',

  'image_id',
  'recommended_action',
];

export const VULNERABILITY_EXPORTED_HEADERNAME = [
  'Account ID',
  'Cluster',
  'CVE ID',
  'CVSS Severity',
  'CVSS Score',
  'EPSS Score',
  'Exploitable',
  'In Use',
  'Fix Version',
  'Workload Name',
  'Workload Kind',
  'Images',
  'Recommended Action',
];

export const IMAGES_VUL_EXPORTED_COLS = [
  'account_id',
  'cluster',
  'vulnerability_id',
  'severity',
  'cvss_score',
  'exploitability_score',
  'exploitable',
  'fix_version',
  'workload_kind',
  'workload_name',
];

export const IMAGES_VUL_EXPORTED_HEADERNAME = [
  'Account ID',
  'Cluster',
  'CVE ID',
  'CVSS Severity',
  'CVSS Score',
  'EPSS Score',
  'Exploitable',
  'Fix Version',
  'Workload Kind',
  'Workload Name',
];

export const SBOM_EXPORTED_HEADERNAME = ['Component', 'Type', 'Path', 'Vulnerabilities'];
export const SBOM_EXPORTED_COLS = ['name', 'type', 'locations', 'vulnerability_counts'];

export const SBOM_VUL_EXPORTED_COLS = [
  'cve_id',
  'severity',
  'cvss_score',
  'exploitability_score',
  'exploitable',
  'affected_workloads',
  'status',
];
export const SBOM_VUL_EXPORTED_HEADERNAME = [
  'CVE ID',
  'CVSS Severity',
  'CVSS Score',
  'EPSS Score',
  'Exploitable',
  'Workload',
  'Status',
];

export const SBOM_WORKLOAD_EXPORTED_COLS = [
  'workload_id',
  'namespace',
  'cluster',
  'risk_factors',
  'vulnerability_counts',
];
export const SBOM_WORKLOAD_EXPORTED_HEADERNAME = [
  'Workload',
  'Namespace',
  'Cluster',
  'Risk Factors',
  'Vulnerabilities',
];
